import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styles: []
})
export class LoadingComponent extends  ExcTranslation implements OnInit {

  @Input() fileName: '';
  @Input() hasText = false;
  constructor() {
    super();
  }

  ngOnInit() {
  }

}
